<template>
    <div class="left-card-container">
        <div class="right-side-title-actions">
            <span class="left-title">{{ $tc('Workspace', 1) }}</span>
            <div class="actions-container">
                <div class="search-container">
                    <v-icon> search </v-icon>
                    <InputField
                        inputType="text"
                        :value="search"
                        :placeholder="$t('Search')"
                        :inputStyle="{
                            borderRadius: '0px',
                            width: '130px',
                            borderTop: 'none',
                            borderRight: 'none',
                            borderLeft: 'none',
                            borderBottom: '1px solid rgba(118, 118, 118, 0.50)'
                        }"
                        @input="handleSearch($event)"
                    />
                </div>
            </div>
        </div>
        <div class="table-div-container">
            <Table
                ref="tableWorkspaces"
                :scroll-id=tableId
                :checkbox="false"
                tdWidth="t-small"
                :loading="loading"
                :headers="headers"
                :items="workspaces"
                :sortable="true"
                @onScrollBottom="onScrollBottom"
                @onScrollTop="onScrollTop"
                @sortClick="onSortClick"
                :emitRowClickBusEvent="true"
            />
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    import { bus } from "@/main.js";
    import Table from "@/newComponents/_Molecules/Table.vue";
    import InputField from "@/newComponents/_Atoms/InputField.vue";
    import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";

    export default {
        name: "TableViewWorkspaces",

        mixins: [managementDatatableMixin],

        components: {
            Table,
            InputField,
        },

        data() {
            return {
                tableId: '2',
                deleteDialogIsOpen: false,
                search: null,
                loading: false,
                scrollTop: 0,
                sortOrder: null,
                scrollHeight: 0,
                selectedRows: [],
                pageNumber: 1,
                pagination: 25,
                currentPageTop: 1,
                currentPageBot: 1,
                lastPage: 2,
                workspaces: [],
                showObjectsTable: false
            };
        },

        mounted() {
            this.getInitialWorkspaces();
            bus.$on('on-row-click', data => {
                this.$emit('set-selected-workspace', data);
            });
        },

        destroyed() {
            bus.$off('on-row-click');
        },

        computed: {
            headers() {
                return [
                    { text: this.$i18n.tc("Label",1), varName: "wp_label" },
                    { text: this.$i18n.t("PlanName"), varName: "wp_plan_name" },
                    { text: this.$i18n.t("Phase"), varName: "wp_status" },
                    { text: this.$i18n.t("Status"), varName: "wp_access_active" },
                ]
            },

        },

        methods: {
            ...mapActions(["fetchAllWorkspacesPaginated","fetchUserAndCompanyWorkspaces","fetchStockMaterialsListObject", "DELETE_MATERIAL_ITEMS"]),

            clearSelectedRows(){
                this.$refs.tableWorkspaces.clearSelectedRowIndex();
            },

            async getInitialWorkspaces() {
                this.currentPageBot = 1
                this.currentPageTop = 1
                let queryParams = {
                    "page[number]": 1,
                    paginate: 25
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }
                this.getAllWorkspaces(queryParams);
            },

            async getAllWorkspaces(queryParams, scrollDirection = null) {
                try {
                    this.loading = true;
                    const workspaces = await this.fetchAllWorkspacesPaginated({
                        queryParams,
                        includes: "manager",
                        fields:
                        "wp_uuid,wp_label,wp_id,wp_geo_json,wp_text_geom,geom,wp_status_active,wp_access_active,wp_status,wp_plan_name,wp_manager",
                    });
                    this.processWorkspacesData(workspaces, scrollDirection);
                } catch (error) {
                    this.$toasted.global.toast_error(error);
                }finally {
                    this.loading = false;
                    this.$nextTick(() => this.updateLocalPagination(this.paginationFromParent));
                }
            },

            processWorkspacesData(workspacesData, scrollDirection = null) {
                let allWorkspaces = null;
                let currentScroll = null;
                let rowElement = null;
                switch (scrollDirection) {
                    case 'top':
                      this.lastPage = workspacesData.meta ? workspacesData.meta.last_page : 1;
                      allWorkspaces = [...workspacesData.data, ...this.workspaces];
                        this.workspaces = Array.from(new Set(allWorkspaces.map(a => a.wp_id)))
                            .map(id => { return allWorkspaces.find(a => a.wp_id === id) })
                        if (this.workspaces.length > 75) {
                            this.workspaces.splice(-(this.workspaces.length - 75));
                            this.currentPageBot--;
                        }

                        currentScroll = document.getElementById(this.tableId).scrollTop;

                        rowElement = document.getElementById("rowId");
                        if (rowElement) {
                            const rowHeight = rowElement.clientHeight;
                            for (let i = 0; i < 25; i++) {
                            const offset = rowHeight * i;
                            document.getElementById(this.tableId).scrollTo({
                                top: currentScroll + offset,
                                behavior: "smooth",
                            });
                            }
                        }
                    break;
                    case 'bottom':
                      this.lastPage = workspacesData.meta ? workspacesData.meta.last_page : 1;
                      allWorkspaces = [...this.workspaces, ...workspacesData.data];
                        this.workspaces = Array.from(new Set(allWorkspaces.map(a => a.wp_id)))
                            .map(id => { return allWorkspaces.find(a => a.wp_id === id) })
                        if (this.workspaces.length > 75) {
                            this.workspaces = this.workspaces.slice(this.workspaces.length - 75);
                        }

                        currentScroll = document.getElementById(this.tableId).scrollTop;

                        rowElement = document.getElementById("rowId");
                        if (rowElement) {
                            const rowHeight = rowElement.clientHeight;
                            for (let i = 0; i < 2; i++) {
                            const offset = rowHeight * i;
                            document.getElementById(this.tableId).scrollTo({
                                top: currentScroll - offset,
                                behavior: "smooth",
                            });
                            }
                        }
                    break;
                    default:
                        this.workspaces = workspacesData.data;
                        this.lastPage = workspacesData.meta ? workspacesData.meta.last_page : 1;
                    break;
                }
            },

            getWorkspacesBottom() {
                this.pagination = 25;
                if (this.workspaces.length >= 75) {
                    this.currentPageTop++;
                }
                this.currentPageBot++;

                let queryParams = {
                    "page[number]": this.currentPageBot,
                    paginate: this.pagination,
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }

                this.getAllWorkspaces(queryParams, 'bottom');
            },

            async getWorkspacesTop() {
                this.pagination = 25;
                this.currentPageTop--;

                let queryParams = {
                    "page[number]": this.currentPageTop,
                    paginate: this.pagination,
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }

                this.getAllWorkspaces(queryParams, 'top');
            },


            handleSearch: _.debounce(function (event) {
                if (event === "") {
                    this.search = null;
                } else {
                    this.search = event;
                }
                this.workspaces = [];
                this.getInitialWorkspaces();

            }, 1000),

            onScrollBottom() {
                if (this.currentPageBot !== this.lastPage) {
                    this.pageNumber++;
                    this.getWorkspacesBottom();
                }
            },

            onScrollTop() {
                if (this.currentPageTop !== 1) {
                    this.pageNumber--;
                    this.getWorkspacesTop();
                }
            },

            onSortClick(sortOrder, index) {
                this.workspaces = [];
                if (sortOrder === "asc") {
                    this.sortOrder = this.headers[index].varName;
                } else if (sortOrder === "desc") {
                    this.sortOrder = `-${this.headers[index].varName}`;
                } else {
                    this.sortOrder = sortOrder;
                }
                this.getInitialWorkspaces();
            }
        },
    };
</script>

<style scoped>
    .search-container {
        display: flex;
        align-items: center;
    }

    .table-div-container {
        height: calc(100% - 39px);
        margin-top: 5px;
    }

    .actions-container {
        display: flex;
        align-items: center;
        gap: 3px;
    }

    .left-title {
        color: #767676;
        font-family: Lato;
        font-size: 10px;
        font-style: normal;
        font-weight: 800;
        line-height: 20px;
        text-transform: uppercase;
    }

    .right-side-title-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 34px;
        overflow: auto;
    }

    .left-card-container {
        width: 100%;
        height: calc(100% - 114px);
        padding-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/newComponents/Data/Delete/TableViewWorkspaces.vue